// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const AuratypesSoftwareCriticality = {
  SoftwareCriticalityHigh: 'high',
  SoftwareCriticalityMedium: 'medium',
  SoftwareCriticalityLow: 'low',
  SoftwareCriticalityUnspecified: 'unspecified',
} as const;
export type AuratypesSoftwareCriticality =
  (typeof AuratypesSoftwareCriticality)[keyof typeof AuratypesSoftwareCriticality];

export function instanceOfAuratypesSoftwareCriticality(value: any): boolean {
  for (const key in AuratypesSoftwareCriticality) {
    if (
      Object.prototype.hasOwnProperty.call(AuratypesSoftwareCriticality, key)
    ) {
      if (
        AuratypesSoftwareCriticality[
          key as keyof typeof AuratypesSoftwareCriticality
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AuratypesSoftwareCriticalityFromJSON(
  json: any,
): AuratypesSoftwareCriticality {
  return AuratypesSoftwareCriticalityFromJSONTyped(json, false);
}

export function AuratypesSoftwareCriticalityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuratypesSoftwareCriticality {
  return json as AuratypesSoftwareCriticality;
}

export function AuratypesSoftwareCriticalityToJSON(
  value?: AuratypesSoftwareCriticality | null,
): any {
  return value as any;
}

export function AuratypesSoftwareCriticalityToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AuratypesSoftwareCriticality {
  return value as AuratypesSoftwareCriticality;
}
